import { render, staticRenderFns } from "./whatsapp-schedule-dialog.vue?vue&type=template&id=c135642a&scoped=true&lang=pug&"
import script from "./whatsapp-schedule-dialog.vue?vue&type=script&lang=ts&"
export * from "./whatsapp-schedule-dialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c135642a",
  null
  
)

export default component.exports